import { namespace } from 'vuex-class';
import { IBetaFlagState } from '@/beta-flag/store/beta-flag.types';

export const BetaFlag = namespace('betaFlag');

export enum EBetaFlagAction {
  FetchBetaFlags = 'fetchBetaFlags',
  FetchContentLibraryFlag = 'fetchContentLibraryFlag',
  FetchDealscoreFlag = 'fetchDealscoreFlag',
  HandleV3OptIn = 'handleV3OptIn',
  HandleBetaOptIn = 'handleBetaOptIn',
  HandleDismissOptIn = 'handleDismissOptIn',
}

export enum EBetaFlagMutation {
  SetFlags = 'setFlags',
  SetContentLibraryFlag = 'setContentLibraryFlag',
  SetDealscoreFlag = 'setDealscoreFlag',
  SetDismissedBetaExpires = 'setDismissedBetaExpires',
}

export const state: IBetaFlagState = {
  dismissedBetaExpires: null,
  flags: {
    v3: null,
    contentLinkBlock: null,
    videoBlock: null,
    editorBlock: null,
    contentLibrary: null,
    dealscore: null,
    editAfterSent: null,
  },
  fetched: false,
};
